export enum OpcoesServicosEnum {
  EMPLACAMENTO = "EMPLACAMENTO",
  VISTORIA = "VISTORIA",
  PRIMEIRO_REGISTRO = "PRIMEIRO_REGISTRO",
}
